import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_V1_URL } from '../../../core/config/api.config';
import { LoginRequest } from '../models/login-request.model';
import { LoginResponse } from '../models/login-response.model';
import { catchError, of } from 'rxjs';
export interface HealthPingResponse {
  status: string;
  timestamp: string;
  version: string;
}

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private readonly http = inject(HttpClient);

  login(payload: LoginRequest): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(
      `${API_V1_URL}/auth/login`,
      payload
    );
  }

  logout(refreshToken: string | null): Observable<void> {
    return this.http.post<void>(
      `${API_V1_URL}/auth/logout`,
      {
        refreshToken,
      }
    );
  }

  refreshToken(refreshToken: string): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(
      `${API_V1_URL}/auth/refresh`,
      {
        refreshToken,
      }
    );
  }

  getBackendVersion(): Observable<HealthPingResponse | null> {
    return this.http
      .get<HealthPingResponse>(`${API_V1_URL}/health/ping`)
      .pipe(catchError(() => of(null)));
  }

}